module.exports = __webpack_public_path__ + "img/122.7c1bb9b4.jpg";